import React, { useState } from "react";
import AlertComponent from "../Components/AlertComponent";
import { useForgotPassword } from "../hooks/auth";
import { Box, Button, Typography, TextField } from "@mui/material";
import { Link } from "react-router-dom";
import "./ForgotPassword.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const { forgotPassword, isLoading, toast, setToast } = useForgotPassword();

  const handleSubmit = async (e) => {
    e.preventDefault();
    forgotPassword({
      email,
    });
  };

  return (
    <section className="min-h-screen grid place-items-center" style={{background: ('../img/grain-texture-dark.png')}}>
      <Box
        className="p-6 rounded-lg forgotpassword-container"
        sx={{
          width: { xs: "100%", md: "500px" },
          background: "white",
          padding: "50px",
          paddingBottom: "50px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <form onSubmit={handleSubmit}>
          <Typography variant="h4" className="text-center font-semibold">
            Forgot Password
          </Typography>
          <Typography variant="body2" className="mt-2 text-gray-800 text-center">
            Submit your email and we will send a link to reset your password
          </Typography>
          <Box sx={{ mt: 6, mb: 2 }}>
            <TextField
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              label="Email"
              variant="outlined"
              fullWidth
              required
              placeholder="richard@piedpiper.com"
            />
          </Box>
          <Button
            disabled={isLoading}
            className="button w-full"
            type="submit"
            variant="contained"
            style={{ background: "linear-gradient(45deg, #ff2045, #3d2fff)" }}
          >
            Submit
          </Button>
          <Typography variant="body2" className="text-sm mt-3 text-center">
            Remember your password?{" "}
            <Link to="/login" className="cursor-pointer text-[#8a2be2]">
              Log in
            </Link>
          </Typography>
        </form>
      </Box>
      <AlertComponent alert={toast} setOpenAlert={setToast} />
    </section>
  );
};

export default ForgotPassword;
